import { render, staticRenderFns } from "./areaList.vue?vue&type=template&id=31b0b52a&scoped=true&"
import script from "./areaList.vue?vue&type=script&lang=js&"
export * from "./areaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0b52a",
  null
  
)

export default component.exports